require('es6-promise').polyfill()
require('drag-drop-touch')
require('./vanilla-cookieconsent')

window.axios = require('axios')
window.fuse = require('fuse.js')
window.Vue = require('vue')

import Popover from 'vue-js-popover'
import VueCookies from 'vue-cookies'

Vue.use(Popover)
Vue.use(VueCookies)

import Search from './components/Search.vue'
import Modal from './components/Modal.vue'
import YoutubeEmbed from './components/YoutubeEmbed.vue'
import YoutubeThumbnail from './components/YoutubeThumbnail.vue'
import WordGame from './components/WordGame.vue'
import MatchSymptoms from './components/MatchSymptoms.vue'
import Carousel from './components/Carousel.vue'
import Entries from './components/Entries.vue'
import InteractiveHouse from './components/InteractiveHouse.vue'
import TeachingResources from './components/TeachingResources.vue'
import WordpressPage from './components/WordpressPage.vue'

Vue.config.productionTip = false

// Access window.location in Vue
Vue.prototype.$location = window.location

// Global modal functions to use in html from Modal component
Vue.prototype.$modal = {
    show(name) {
        location.hash = name
    },
    hide(name) {
        location.hash = '#/'
    },
}

new Vue({
    components: {
        Search,
        Modal,
        YoutubeEmbed,
        YoutubeThumbnail,
        Carousel,
        Entries,
        WordGame,
        MatchSymptoms,
        InteractiveHouse,
        TeachingResources,
        WordpressPage,
    },
}).$mount('#app')
